export default __webpack_public_path__ + "static/media/loader.f3a922bf.svg";